import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import {
  clearBusAssignmentSchedule,
  getBusAssignmentSchedule,
} from '../../../../actions/bus/BusAssignmentSchedule';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { BUS_ASSIGNMENT_SCHEDULE_PATH } from '../../../../config/paths';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';
import BusAssignmentScheduleBasicInformationResource from './BusAssignmentScheduleBasicInformationResource';
import BusAssignmentScheduleToolbar from './BusAssignmentScheduleToolbar';

const BusAssignmentSchedule = ({
  breadcrumbs,
  loading,
  dispatchGetBusAssignmentSchedule,
  dispatchClearBusAssignmentSchedule,
  busAssignmentSchedule,
  match: {
    params: { id: busAssignmentScheduleId },
  },
}) => {
  useLayoutEffect(() => {
    dispatchGetBusAssignmentSchedule({ busAssignmentScheduleId });
    return () => dispatchClearBusAssignmentSchedule();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (busAssignmentSchedule.isEmpty())
    content = <NoDataResource returnPage={BUS_ASSIGNMENT_SCHEDULE_PATH} />;
  else {
    const busAssignmentScheduleJson = busAssignmentSchedule.toJS();
    content = (
      <BusAssignmentScheduleBasicInformationResource
        {...busAssignmentScheduleJson}
      />
    );

    toolbar = (
      <BusAssignmentScheduleToolbar
        busAssignmentScheduleId={busAssignmentScheduleJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Asignación de Rutas"
      content={content}
    />
  );
};

BusAssignmentSchedule.propTypes = {
  dispatchGetBusAssignmentSchedule: PropTypes.func.isRequired,
  dispatchClearBusAssignmentSchedule: PropTypes.func.isRequired,
  busAssignmentSchedule: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  match: matchPropTypes.isRequired,
};

const mapStateToProps = ({ BusUnit }) => ({
  breadcrumbs: [
    ...BusUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Asignación de Rutas',
      href: BUS_ASSIGNMENT_SCHEDULE_PATH,
    },
    {
      text: 'Asignación de Rutas',
      href: '',
    },
  ],
  busAssignmentSchedule: BusUnit.BusAssignmentSchedule.getIn([
    'current',
    'content',
  ]),
  loading: !BusUnit.BusAssignmentSchedule.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBusAssignmentSchedule: getBusAssignmentSchedule,
  dispatchClearBusAssignmentSchedule: clearBusAssignmentSchedule,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusAssignmentSchedule);
